import { zodResolver } from '@hookform/resolvers/zod';
import { t } from 'i18next';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

const TRANS_KEY = 'FORM.FORM_ERRORS';

export const taskFormSchema = z
  .object({
    title: z.string().refine((value) => value.trim().length > 0, {
      message: t(`tasks:${TRANS_KEY}.TITLE_REQUIRED`),
    }),
    description: z.string().refine((value) => value.trim().length > 0, {
      message: t(`tasks:${TRANS_KEY}.DESCRIPTION_REQUIRED`),
    }),
    context: z.string(),
    priority: z.enum(['HIGH', 'MEDIUM', 'LOW', 'INFORMATIVE']).nullable(),
    userIds: z.array(z.string()),
    teamIds: z.array(z.string()),
  })
  .refine(
    (value) => value.userIds.length + value.teamIds.length >= 1,
    {
      message: t(`tasks:${TRANS_KEY}.AUDIENCE_REQUIRED`),
      path: ['userIds'],
    }
  );

export type TaskFormSchemaType = z.infer<typeof taskFormSchema>;

export const taskFormDefaultValues: TaskFormSchemaType = {
  title: '',
  description: '',
  context: '',
  priority: 'MEDIUM',
  userIds: [],
  teamIds: [],
};

type UseTaskFormReturnType = UseFormReturn<TaskFormSchemaType>;

export const useTaskForm = (
  defaultValues: TaskFormSchemaType = taskFormDefaultValues
): UseTaskFormReturnType => {
  return useForm({
    defaultValues,
    resolver: zodResolver(taskFormSchema),
  });
};
